class TextTypingAnimation {
    constructor(element, options = {}) {
        this.element = element;
        this.prefix = options.prefix || '';
        this.words = options.words || [];
        this.suffix = options.suffix || '';
        this.typingSpeed = options.typingSpeed || 100;
        this.deletingSpeed = options.deletingSpeed || 50;
        this.pauseTime = options.pauseTime || 2000;
        this.currentWordIndex = 0;
        this.currentText = '';
        this.isDeleting = false;
        this.isPaused = false;
    }

    async animate() {
        if (this.isPaused) return;

        const currentWord = this.words[this.currentWordIndex];
        
        if (!this.isDeleting) {
            // Typing
            this.currentText = currentWord.substring(0, this.currentText.length + 1);
        } else {
            // Deleting
            this.currentText = this.currentText.substring(0, this.currentText.length - 1);
        }

        // Update the text content
        this.element.textContent = this.prefix + this.currentText + this.suffix;

        // Set typing speed
        let typeSpeed = this.typingSpeed;
        
        if (this.isDeleting) {
            typeSpeed = this.deletingSpeed;
        }

        // If word is complete
        if (!this.isDeleting && this.currentText === currentWord) {
            this.isPaused = true;
            await new Promise(resolve => setTimeout(resolve, this.pauseTime));
            this.isPaused = false;
            this.isDeleting = true;
        } else if (this.isDeleting && this.currentText === '') {
            this.isDeleting = false;
            this.currentWordIndex = (this.currentWordIndex + 1) % this.words.length;
        }

        setTimeout(() => this.animate(), typeSpeed);
    }
}

// Initialize all typing animations on the page
document.addEventListener('DOMContentLoaded', () => {
    const typingElements = document.querySelectorAll('.typing-text-animation');
    
    typingElements.forEach(element => {
        const prefix = element.dataset.prefix || '';
        const words = (element.dataset.words || '').split(',').map(word => word.trim());
        const suffix = element.dataset.suffix || '';
        
        const animation = new TextTypingAnimation(element, {
            prefix,
            words,
            suffix,
            typingSpeed: parseInt(element.dataset.typingSpeed) || 100,
            deletingSpeed: parseInt(element.dataset.deletingSpeed) || 50,
            pauseTime: parseInt(element.dataset.pauseTime) || 2000
        });
        
        animation.animate();
    });
}); 